var map = {
	"./android-icon-144x144.png": 78415,
	"./android-icon-192x192.png": 92279,
	"./android-icon-256x256.png": 89399,
	"./android-icon-36x36.png": 57269,
	"./android-icon-48x48.png": 6727,
	"./android-icon-72x72.png": 98741,
	"./android-icon-96x96.png": 48333,
	"./apple-icon-114x114.png": 40776,
	"./apple-icon-120x120.png": 12312,
	"./apple-icon-144x144.png": 81540,
	"./apple-icon-152x152.png": 92476,
	"./apple-icon-180x180.png": 30300,
	"./apple-icon-57x57.png": 1560,
	"./apple-icon-60x60.png": 11540,
	"./apple-icon-72x72.png": 37246,
	"./apple-icon-76x76.png": 86726,
	"./apple-icon-precomposed.png": 59283,
	"./apple-icon.png": 68883,
	"./browserconfig.xml": 4077,
	"./favicon-16x16.png": 93960,
	"./favicon-32x32.png": 94116,
	"./favicon-96x96.png": 85832,
	"./favicon.ico": 18707,
	"./ms-icon-144x144.png": 39760,
	"./ms-icon-150x150.png": 78948,
	"./ms-icon-310x310.png": 59112,
	"./ms-icon-70x70.png": 66866,
	"./safari-pinned-tab.svg": 62587,
	"favicons/android-icon-144x144.png": 78415,
	"favicons/android-icon-192x192.png": 92279,
	"favicons/android-icon-256x256.png": 89399,
	"favicons/android-icon-36x36.png": 57269,
	"favicons/android-icon-48x48.png": 6727,
	"favicons/android-icon-72x72.png": 98741,
	"favicons/android-icon-96x96.png": 48333,
	"favicons/apple-icon-114x114.png": 40776,
	"favicons/apple-icon-120x120.png": 12312,
	"favicons/apple-icon-144x144.png": 81540,
	"favicons/apple-icon-152x152.png": 92476,
	"favicons/apple-icon-180x180.png": 30300,
	"favicons/apple-icon-57x57.png": 1560,
	"favicons/apple-icon-60x60.png": 11540,
	"favicons/apple-icon-72x72.png": 37246,
	"favicons/apple-icon-76x76.png": 86726,
	"favicons/apple-icon-precomposed.png": 59283,
	"favicons/apple-icon.png": 68883,
	"favicons/browserconfig.xml": 4077,
	"favicons/favicon-16x16.png": 93960,
	"favicons/favicon-32x32.png": 94116,
	"favicons/favicon-96x96.png": 85832,
	"favicons/favicon.ico": 18707,
	"favicons/ms-icon-144x144.png": 39760,
	"favicons/ms-icon-150x150.png": 78948,
	"favicons/ms-icon-310x310.png": 59112,
	"favicons/ms-icon-70x70.png": 66866,
	"favicons/safari-pinned-tab.svg": 62587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63320;